import type { ReactNode } from 'react';

export function TableShell({ children }: { readonly children: ReactNode }): ReactNode {
  return (
    <div className="overflow-x-auto rounded-card border border-hairline bg-white shadow-sm dark:border-dark-line dark:bg-dark-panel">
      {children}
    </div>
  );
}

export function TableHeaderRow({ children }: { readonly children: ReactNode }): ReactNode {
  return (
    <div className="flex w-full items-center gap-4 border-b border-hairline bg-white px-4 py-3 dark:border-dark-line dark:bg-white/5">
      {children}
    </div>
  );
}

export function HeaderCell({
  className = '',
  children,
}: {
  readonly className?: string;
  readonly children: ReactNode;
}): ReactNode {
  return (
    <span className={`text-sm font-semibold text-[rgb(102,112,133)] ${className}`}>
      {children}
    </span>
  );
}

export function tableRowClass(isFirst: boolean, extra = ''): string {
  return `flex w-full items-center gap-4 px-4 py-3 text-left transition hover:bg-mist/70 dark:hover:bg-white/5 ${
    isFirst ? '' : 'border-t border-hairline dark:border-dark-line'
  } ${extra}`;
}
